<template>
  <b-modal
    id="export-template"
    size="md"
    :title="$translate(title)"
    hide-footer
    centered
    content-class="rounded-8"
    @close="clear"
  >
    <div class="row">
      <span style="width:100%">
        <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
          <Input v-model="data.site" form-group-id="Website" placeholder="Website URL" :required="true" />
        </div>
        <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
          <Textarea v-model="data.token" form-group-id="API key" placeholder="API key" :required="true" />
        </div>
      </span>
      <div class="row mx-0 w-100">
        <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between">
          <b-button
            variant="outline-secondary"
            size="lg"
            :class="`btn-delete-device mr-3 px-5 ${!showAPIBlock && 'close-position'}`"
            @click="close"
          >
            {{ 'Close' | i18n }}
          </b-button>
          <b-button
            variant="outline-primary"
            size="lg"
            class="btn-delete-device px-5"
            :disabled="!data.site || !data.token"
            @click="onSubmit"
          >
            {{ 'Export' | i18n }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from '../../common/input';
import Textarea from '../../common/textarea';
import { NotificationMixin, ReportsMixin } from '../../../../mixins';

export default {
  title: 'Export template',
  components: { Input, Textarea },
  mixins: [NotificationMixin, ReportsMixin],
  props: {
    title: {
      type: String,
      default: 'Export Template'
    },
    selectedList: {
      type: Array,
      default: () => []
    },
    onExport: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      data: {
        site: '',
        token: ''
      },
      showAPIBlock: false
    };
  },
  methods: {
    clear() {
      this.showAPIBlock = false;
      this.data = {
        site: '',
        token: ''
      };
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'export-template');
      this.clear();
    },
    async onSubmit() {
      try {
        await this.onExport({ ...this.data, templates: this.selectedList.map(t => t.id) });
        this.$root.$emit('bv::hide::modal', this.id);
        this.showNotification({ type: 'success', message: this.$translate('success') });
        this.close();
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep  #add-customer .modal-dialog {
  max-width: 700px !important;
}

::v-deep  .button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.center-color {
  justify-content: center;
  align-items: center;
  display: flex;
}

.action-button {
  border: 2px solid #2260ff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  font-weight: 500;
  width: 200px;
  height: 50px;
  cursor: pointer;
}

.action-block {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.close-position {
  margin-right: 0px !important;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
